const e = "update:modelValue";
export {
  e as U
};
